module.exports = __webpack_public_path__ + "img/9-1-IMG_3001.8f50e045.png";